import React, { Component, useContext } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import StyleContext from 'isomorphic-style-loader/StyleContext';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';

import { withRtl } from '../../components/hoc';
import style from './SchoolsSplash.scss'; // eslint-disable-line css-modules/no-unused-class
import SearchIcon from '../../components/icons/Search';
import LinkCard from '../../components/LinkCard';
import messages from '../../locale/messages';
import getAdmissionProcesses from '../../actions/admissionProcesses';
// import { getSchoolsPrograms } from '../../actions/schools';
const localMessages = defineMessages({
  splashPageHeader: {
    id: 'splashPage.header',
    defaultMessage: 'Browse NYC Schools',
    description: 'Header for Splash Page for schools public directory',
  },
  splashPageHelpText: {
    id: 'splashPage.helpText',
    defaultMessage: 'Let’s start finding some schools for your student:',
    description: 'Help text for Splash Page for schools public directory',
  },
});


class SchoolsSplash extends Component {
  static propTypes = {
    admissionProcesses: PropTypes.shape({
      count: PropTypes.number,
      results: PropTypes.arrayOf(
        PropTypes.shape({
          // name: PropTypes.string,
        }),
      ),
      alertsLoaded: PropTypes.bool,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    getAdmissionProcesses: PropTypes.func.isRequired,
  };
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      admissionProcesses: {},
    };
  }
  componentDidMount() {
    this.context.insertCss(style);
    this.props.getAdmissionProcesses();
  }
  
  render() {
    const { intl } = this.props;
    const { locale } = intl;
    const { admissionProcesses} = this.props;

    // const linkCardSchools = [
    //   { schoolType: 'HighSchool', link: 'high-school' }, HS
    //   { schoolType: 'MiddleSchool', link: 'middle-school' },
    //   { schoolType: 'Kindergarten', link: 'kindergarten' },
    //   { schoolType: 'PreK', link: 'pre-k' },
    //   { schoolType: '3K', link: '3k' },
    //   { schoolType: 'GiftedTalented', link: 'gt-app' },
    // ];
    return (
      <>
        <main className={style.root} role="presentation">
          <div className={style.wrapper}>
            <h1>
              <SearchIcon size={45} fill="#4ee4b3" />
              <FormattedMessage {...localMessages.splashPageHeader} />
            </h1>
            <p>
              <FormattedMessage {...localMessages.splashPageHelpText} />
            </p>
            <div className={style.cards}>
              {admissionProcesses.results && admissionProcesses.results.map(({ id, public_directory_name, public_directory_desc, public_url}) => (
                <LinkCard
                  key= {id}
                  headingText= {public_directory_name}
                  ariaLabel= {public_directory_desc} 
                  helpText= {public_directory_desc} 
                  href={`/${locale}/schools/${public_url}/`}
                />
              ))}
            </div>
          </div>
        </main>
        <div className={style.stripedBackground}>
          <div className={style.grey}>
            <div className={style.stripes} />
          </div>
        </div>
      </>
    );
  }
}

const mapState = ({
  admissionProcesses,
}) => ({
  admissionProcesses,
});

const mapDispatch = {
  getAdmissionProcesses,
};

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(
    mapState,
    mapDispatch,
  ),
)(SchoolsSplash);


